import http from '@/core/http/index';
import { DOMAIN_SYSTEM_ENUM } from '@toy/utils';
import * as Types from './types';

/**
 * 列表
 * @see https://yapi.tiangong.site/project/483/interface/api/25115
 *
 * @请求方法: GET
 * @请求地址: /cms-service/web/user-agreement/page
 * @更新时间: 2023-07-21 10:08:13
 */
export const getWebUserAgreementPageApi = (params: Types.GetWebUserAgreementPageApiReq) => {
  return http.get<Types.GetWebUserAgreementPageApiRes>({
    url: '/cms-service/web/user-agreement/page',
    params,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

/**
 * 更新状态
 * @see https://yapi.tiangong.site/project/483/interface/api/25151
 *
 * @请求方法: POST
 * @请求地址: /cms-service/web/user-agreement/state
 * @更新时间: 2023-07-21 10:08:13
 */
export const postWebUserAgreementStateApi = (params: { agreementId: string; state: string; }) => {
  return http.post({
    url: '/cms-service/web/user-agreement/state',
    params,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

/**
 * 详情
 * @see https://yapi.tiangong.site/project/483/interface/api/25124
 *
 * @请求方法: GET
 * @请求地址: /cms-service/web/user-agreement/{agreementId}
 * @更新时间: 2023-07-21 10:08:13
 */
export const getWebUserAgreementAgreementIdApi = (agreementId: string) => {
  return http.get<Types.GetWebUserAgreementAgreementIdApiRes>({
    url: `/cms-service/web/user-agreement/${agreementId}`,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

/**
 * 修改
 * @see https://yapi.tiangong.site/project/483/interface/api/25142
 *
 * @请求方法: PUT
 * @请求地址: /cms-service/web/user-agreement/update
 * @更新时间: 2023-07-21 10:08:13
 */
export const putWebUserAgreementUpdateApi = (data: Types.PutWebUserAgreementUpdateApiReq) => {
  return http.put({
    url: '/cms-service/web/user-agreement/update',
    loading: true,
    data,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

/**
 * 新建
 * @see https://yapi.tiangong.site/project/483/interface/api/25133
 *
 * @请求方法: POST
 * @请求地址: /cms-service/web/user-agreement/save
 * @更新时间: 2023-07-21 10:08:13
 */
export const postWebUserAgreementSaveApi = (data: Types.PostWebUserAgreementSaveApiReq) => {
  return http.post({
    url: '/cms-service/web/user-agreement/save',
    loading: true,
    data,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
